import { Injectable } from '@angular/core';

import { HttpService, NotificationService, SalesOrderLine, TmsWebBaseEditCreateService } from 'tms-lib';
import { SalesOrderLinePicking } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderLinePickingService extends TmsWebBaseEditCreateService<SalesOrderLine, SalesOrderLinePicking> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesOrderLinePicking', $localize`Sales Order Line Picking`, httpService, notificationService);
  }
}
